import { lazy } from 'react';

export const GmProductAddRequestPage = lazy(() => import('./AddRequest/AddRequest'));
export const GmProductRequestsEditPage = lazy(() => import('./EditPage/EditPage'));
export const GmProductRegistryEditPage = lazy(() => import('./EditPage/EditPage'));
export const GmProductInactiveEditPage = lazy(() => import('./EditPage/EditPage'));
export const GmProductRequestsViewPage = lazy(() => import('./ViewPage/ViewPage'));
export const GmProductRegistryViewPage = lazy(() => import('./ViewPage/ViewPage'));
export const GmProductInactiveViewPage = lazy(() => import('./ViewPage/ViewPage'));
